import 'client-only'

import storage from '@/lib/storage'
import { Cable, Channel, createCable } from '@anycable/core'
import { nanoid } from '@reduxjs/toolkit'

export const obtainCable: (() => Cable | null) & { __CABLE__?: Cable } = () => {
  if (obtainCable.__CABLE__) return obtainCable.__CABLE__
  if (!process.env.EXPO_PUBLIC_ANYCABLE_ENDPOINT) return null

  obtainCable.__CABLE__ = createCable(process.env.EXPO_PUBLIC_ANYCABLE_ENDPOINT)
  return obtainCable.__CABLE__
}

const CONNECTION_TIMEOUT = 2000

export function ensureChannelSubscribed(channel: Channel) {
  return new Promise<Channel>((resolve, reject) => {
    const cable = obtainCable()
    if (!cable) return reject()

    cable
      .subscribe(channel)
      .ensureSubscribed()
      .then(() => resolve(channel))
      .catch(reject)
    setTimeout(() => reject('create connection failed'), CONNECTION_TIMEOUT)
  })
}

const ANYCABLE_CLIENT_ID_STORAGE_KEY = '__next-anycable-client-id'

export function getClientId() {
  let clientId = storage.get<string>(ANYCABLE_CLIENT_ID_STORAGE_KEY)
  if (!clientId) {
    clientId = `anycable-nextapp-${nanoid()}`
    storage.set(ANYCABLE_CLIENT_ID_STORAGE_KEY, clientId)
  }
  return clientId
}
